import apiClient from '@u/apiClient'
import GetWikiContactByIdController from '@/wayfinder/actions/App/Http/Controllers/WikiContact/GetWikiContactByIdController'
import GetWikiContactListForACityController from '@/wayfinder/actions/App/Http/Controllers/WikiContact/GetWikiContactListForACityController'
import CreateWikiContactController from '@/wayfinder/actions/App/Http/Controllers/WikiContact/CreateWikiContactController'
import UpdateWikiContactController from '@/wayfinder/actions/App/Http/Controllers/WikiContact/UpdateWikiContactController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
import AttachWikiContactToPlaceController from '@/wayfinder/actions/App/Http/Controllers/WikiContact/AttachWikiContactToPlaceController'
import DetachWikiContactToPlaceController from '@/wayfinder/actions/App/Http/Controllers/WikiContact/DetachWikiContactToPlaceController'

let base_errors = { deceased: {}, events: [] }

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  async fetchWikiContactById({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(
        GetWikiContactByIdController.get({ contact: payload.wiki_contact_id })
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setContact', response.data.wiki_contact)
        }
      })
      .catch(async (reason) => {
        await console.error('fetchWikiContactById', reason)
      })
  },
  async fetchNewWikiContact({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetNewModelController.get({ query: { model: 'wikiContact' } }))
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setContact', response.data.wikiContact)
        }
      })
      .catch(async (reason) => {
        await console.error('fetchNewWikiContact', reason)
      })
  },
  async fetchWikiContactByCity({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(
        GetWikiContactListForACityController.get({ city: payload.wiki_city_id })
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setWikiContactList', response.data.contacts)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },
  async storeWikiContact({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(CreateWikiContactController.post(), payload.wiki_contact)
      .then(async (response) => {
        if (response.status === 200) {
          commit('setContact', response.data.contact)

          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('storeWikiContact', reason)
      })
  },
  async updateWikiContact({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(
        UpdateWikiContactController.put({ contact: payload.wiki_contact_id }),
        payload.wiki_contact
      )
      .then(async (response) => {
        if (response.status === 200) {
          commit('setContact', response.data.contact)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('updateWikiContact', reason)
      })
  },
  async attachWikiContactToWikiPlace({ commit }, payload) {
    await apiClient
      .route(
        AttachWikiContactToPlaceController.post(
          { contact: payload.wiki_contact_id, place_id: payload.wiki_place_id },
          { query: { type: payload.wiki_place_type } }
        )
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setPlace', response.data.place)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('attachWikiContactToWikiPlace', reason)
      })
  },
  async detachWikiContactFromWikiPlace({ commit }, payload) {
    await apiClient
      .route(
        DetachWikiContactToPlaceController.post(
          { contact: payload.wiki_contact_id, place_id: payload.wiki_place_id },
          { query: { type: payload.wiki_place_type } }
        )
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setPlace', response.data.place)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('detachWikiContactFromWikiPlace', reason)
      })
  }
}
